import * as React from 'react';
import './SettingsBodyToast.css'
import { SettingsApplication } from '../model'

export type ValueProps = {
  success?: boolean,
  apply?: boolean,
  timestamp?: Date,
  application?: SettingsApplication,
}

export type Props = ValueProps

const getToastMessage = (success?: boolean, apply?: boolean, application?: SettingsApplication) => {
  const appText = application ? `for ${application.name}` : ''
  if (application && application.status !== 'STARTED') {
    return 'Your changes will take effect once your application is restarted'
  } else if (success) {
    return !apply ? `Anypoint Monitoring is successfully enabled ${appText}` : `Anypoint Monitoring is successfully disabled ${appText}`
  } else {
    return !apply ? `Enabling Anypoint Monitoring ${appText} failed. Please try again` :
      `Disabling Anypoint Monitoring ${appText} failed. Please try again`
  }
}

const getToastClass = (success?: boolean, apply?: boolean, application?: SettingsApplication) => {
  if (application && application.status !== 'STARTED') {
    return 'toast-disable'
  } else if (success) {
    return !apply ? 'toast-apply' : 'toast-disable'
  } else {
    return 'toast-error'
  }
}

const toastTime = 4000

export const SettingsBodyToast = (props: Props) => {
  const now = new Date()
  if (props.timestamp && (now.getTime() - props.timestamp.getTime()) <= toastTime) {
    return (
      <div
        data-test-id={`settings-body-${getToastClass(props.success, props.apply, props.application)}`}
        className={`settings-body-toast ${getToastClass(props.success, props.apply, props.application)}`}
      >
        {getToastMessage(props.success, props.apply, props.application)}
      </div>
    );
  }
  return null;
}
